module.exports = __webpack_public_path__ + "media/media/about/6-f294289373ceca4a7a70cbf9e5ffe6fd.jpg";